{
  "absent": "Absent",
  "account": "Account",
  "activate": "Activate",
  "active": "Active",
  "activities": "Activities",
  "add": "Add",
  "address": "Address",
  "approve": "Approve",
  "attended": "Attended",
  "cancel": "Cancel",
  "classroom": "Classroom",
  "clear": "Clear",
  "clearDate": "Clear Date",
  "clearFilters": "Clear Filters",
  "close": "Close",
  "continue": "Continue",
  "courseUpper": "Course",
  "date": "Date",
  "dateOfBirth": "Date of birth",
  "day": "Day",
  "days_one": "{{count}} Day",
  "days_other": "{{count}} Days",
  "deactivate": "Deactivate",
  "deactivated": "Deactivated",
  "delete": "Delete",
  "discardChanges": "Discard Changes",
  "edit": "Edit",
  "email": "Email",
  "emailInUse": "Email is already in use!",
  "encryption": {
    "decryptError": "Failed to decrypt this value",
    "encryptError": "Failed to encrypt this value"
  },
  "enrolmentUpper": "Enrolment",
  "errors": {
    "entityNotFound": "{{entity}} not found",
    "invalid_date_time": "Please provide a valid date and time",
    "loadFailedDescription": "Something went wrong while loading. Please try again.",
    "loadFailedTitle": "Couldn't load data",
    "unable_to_complete": "Unable to complete the process, with error: {{error}}"
  },
  "evaluations": "Evaluations",
  "failed": "Failed",
  "firstName": "First Name",
  "fixed": "Fixed",
  "flexible": "Flexible",
  "hide": "Hide",
  "inactive": "Inactive",
  "instructor": "Instructor",
  "invoiceDeliveryMethods": {
    "email": "Email",
    "mail": "Mail",
    "none": "None",
    "other": "Other"
  },
  "lastName": "Last Name",
  "lessons": "Lessons",
  "location": "Location",
  "locationTypes": {
    "driveTest": "Drive Test",
    "office": "Office",
    "pit": "Pit",
    "virtual": "Virtual",
    "yarn": "Yard"
  },
  "logout": "Logout",
  "middleName": "Middle Name",
  "month": "Month",
  "more": "more",
  "name": "Name",
  "next": "Next",
  "noResults": "No Results",
  "noResultsFound": "No results found",
  "notApplicable": "N/A",
  "notAvailable": "Not Available",
  "notSent": "Not sent",
  "notes": "Notes",
  "observation": "Observation",
  "observers": "Observers",
  "open": "Open",
  "other": "Other",
  "pagination": {
    "goToFirstPage": "Go to first page",
    "goToLastPage": "Go to last page",
    "goToNextPage": "Go to next page",
    "goToPreviousPage": "Go to previous page",
    "morePages": "More pages",
    "pagination": "Pagination",
    "rowsPerPage": "Rows per page",
    "rowsResults": "{{from}} to {{to}} of {{total}} results",
    "showingPrefix": "Showing "
  },
  "payerGroups": {
    "company": "Company",
    "government": "Government",
    "indigenousBand": "Indigenous Band",
    "insurance": "Insurance",
    "other": "Other",
    "students": "Student",
    "workerCompany": "Worker Company"
  },
  "payment": "${{amount}}",
  "phoneNumber": "Phone Number",
  "pickDatePlaceholder": "Pick a date",
  "previous": "Previous",
  "publish": "Publish",
  "reject": "Reject",
  "retry": "Try again",
  "review": "Review",
  "save": "Save",
  "saveChanges": "Save changes",
  "select": "Select",
  "selectCampus": "Select Campus",
  "selectDatePlaceholder": "Select a date",
  "sendInvite": "Send Invite",
  "sent": "Sent",
  "share": "Share",
  "show": "Show",
  "sidebar": {
    "title": "Sidebar",
    "toggle": "Toggle sidebar"
  },
  "signOut": "Sign out",
  "signed": "Signed",
  "skills": "Skills",
  "staffRole": {
    "campusManager": "Campus Manager",
    "centralManager": "Central Manager",
    "csr": "CSR",
    "instructor": "Instructor",
    "owner": "Owner"
  },
  "staffUpper": "Staff",
  "startTime": "Start Time",
  "studentNumber": "Student #",
  "studentUpper": "Student",
  "students": "Students",
  "tbd": "TBD",
  "time": "Time",
  "toasts": {
    "success": {
      "allJobsProcessed": "All jobs processed successfully"
    }
  },
  "today": "Today",
  "total": "Total",
  "type": "Type",
  "undo": "Undo",
  "upcoming": "Upcoming",
  "upload": "Upload",
  "validation": {
    "atLeastOneField": "At least one field must be provided",
    "atLeastOneOption": "At least one option must be selected",
    "invalidEmail": "Invalid email",
    "invalidNumber": "Invalid number",
    "invalidPassword": "The password is invalid",
    "numberMustBeNonNegative": "Number must be non-negative",
    "phoneNumber10Digits": "Phone number must be 10 digits",
    "requiredField": "This field is required",
    "requiredFields": "These fields are required",
    "requiredNonNegative": "Invalid number",
    "roleIsRequired": "Role is required"
  },
  "vehicles": "Vehicles",
  "view": "View",
  "week": "Week",
  "workWeek": "Work Week",
  "year": "Year"
}
